/* eslint-disable no-case-declarations */
import { formatPrice, getCache, isMobile } from '@/utils';
import Tracker from './tracker';
import { productsUnionByType } from '../configs/product.config';
import TrackerQueue from './TrackerQueue';
import { armsErrorSend } from '../libs/armsErrorSend';
import { feishuRobotSend } from '@/utils/feishuRobot';
import { getPECampaignName } from '@/utils';
import { getItemPrimeSkuId, PrimeCommodityMap } from '../configs/prime.config';

// beacon || fecth
const ABT_SEND_HIT_METHOD = 'fetch';

class ThirdPartyTracker extends Tracker {
  PushEngageTracker = {
    // 商品加购 -- PushEngage开始推送通知
    addToCart: function (param) {
      try {
        if (window?._peq && ['en_us', 'zh_tw', 'ja_jp'].includes(param?.language)) {
          const campaignName = getPECampaignName(param?.language);

          var trigger = {
            'campaign_name': campaignName,
            'event_name': 'add-to-cart',
            // 数据由运营同事在平台完成配置
            // 'data': {},
          };

          // [event,data,回调方法]
          window._peq.push(['add-to-trigger', trigger]);
        }
      } catch (err) {
        feishuRobotSend({
          text: ['PushEngage停止推送失败', err],
          at: ['xyk'],
        });
      }
    },

    // 商品结账 -- PushEngage停止推送通知
    checkOut: function (param) {
      try {
        if (window?._peq && ['en_us', 'zh_tw', 'ja_jp'].includes(param?.language)) {
          const campaignName = getPECampaignName(param?.language);

          const trigger = {
            'campaign_name': campaignName,
            'event_name': 'checkout',
            // 通过PushEngage挽回下单无需上报数据
            'data': {},
          };

          window._peq.push([
            'add-to-trigger',
            trigger,
            function (res) {
              console.log(res);
            },
          ]);
        }
      } catch (err) {
        feishuRobotSend({
          text: ['PushEngage停止推送失败', err],
          at: ['xyk'],
        });
      }
    },
  };

  /**
   * ABTasty 平台相关上报
   *  1. 用户行为转化： 通过universal collect上报到ABTasty平台，进行Conversation转化。
   *    https://docs.developers.flagship.io/docs/universal-collect-documentation
   *  2. 用户曝光：通过Decision API进行曝光。
   *    https://docs.developers.flagship.io/docs/decision-api#campaign-activation
   */
  ABTastyTracker = {
    URL: {
      EVENT: 'https://events.flagship.io',
      DECISION_API: 'https://decision.flagship.io/v2',
    },
    ENV: {
      PREPROD: 'cnpejhnh75j1i5o62e3g',
      PROD: 'cnpejhnh75j1i5o62e30',
    },
    EVENT_CATEGORY: {
      USER_ENGAGEMENT: 'User Engagement',
      ACTION_TRACKING: 'Action Tracking',
    },
    HIT_TYPE: {
      EVENT: 'EVENT',
      TRANSACTION: 'TRANSACTION',
      ITEM: 'ITEM',
      SCREENVIEW: 'SCREENVIEW',
      PAGEVIEW: 'PAGEVIEW',
    },
    /**
     * _sendHit - 调用fetch进行universal collect上报
     *  @param {object} params
     *    {
     *      vid: string
     *      ea: string
     *      t: this._HIT_TYPE
     *      ec?: this._EVENT_CATEGORY
     *      el?: string
     *      qt?: number
     *    }
     */
    commonSendHit: function (params) {
      if (!window?.CookieConsentInstance?.consent?.statistics) return;
      const cache = getCache();
      const visitorId = cache.getCookie('flagship_visitor_id');
      if (!visitorId) return;
      const data = JSON.stringify({
        cid: window?.isProd ? this.ENV.PROD : this.ENV.PREPROD,
        h: [
          {
            // The ec must be equal to Action Tracking or User Engagement
            cuid: null,
            vid: visitorId,
            ...params,
          },
        ],
        t: 'BATCH',
        ds: 'APP',
        qt: 0,
      });

      if (ABT_SEND_HIT_METHOD === 'beacon' && navigator.sendBeacon) {
        // 在一些点击后立刻跳转的click，如产品页加车，使用fetch上报会失败
        const blob = new Blob([data], { type: 'application/json; charset=UTF-8' }); // the blob

        navigator.sendBeacon(this.URL.EVENT, blob);
      } else {
        fetch(this.URL.EVENT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: data,
          credentials: 'omit',
          keepalive: true,
        });
      }
    },
    /** Event类型的事件上报
     * @param {object} { KPI: string 事件名称, label?: string }
     */
    sendEvent: function (param) {
      this.commonSendHit({
        ea: param.KPI,
        t: this.HIT_TYPE.EVENT,
        ec: this.EVENT_CATEGORY.ACTION_TRACKING,
        el: param.label,
        qt: 560,
      });
    },

    /** Transaction类型的事件上报
     * @param {object}
     *  {
     *     KPI: string 事件名称
     *     orderNumber: string 订单ID，唯一
     *     paymentMethod: string 支付方式
     *     currency: string 支付货币
     *     revenue?: number 订单总额
     *     shipping?: number 运费
     *     tax?: number 税费
     *  }
     */
    sendTranscation: function (param) {
      this.commonSendHit({
        t: this.HIT_TYPE.TRANSACTION,
        ta: param.KPI,
        pm: param.paymentMethod,
        tid: param.orderNumber,
        tc: param.currency,
        tr: param.revenue,
        ts: param.shipping,
        tt: param.tax,
        el: param.label,
        qt: 560,
      });
    },

    /**
     *  用户曝光
     *  @param {object} { variationGroupId: string, variationId: string}
     */
    exposedVisitor: function (param) {
      const cache = getCache();
      const visitorId = cache.getCookie('flagship_visitor_id');

      fetch(`${this.URL.DECISION_API}/activate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cid: this.ENV,
          vid: visitorId,
          caid: param.variationGroupId,
          vaid: param.variationId,
        }),
      });
    },
  };

  /**
   * VWO ABT event tracker
   * @param payload 注意参数的数据类型一定要和VWO后台匹配
   */
  VWOTracker = (event, payload) => {
    if (typeof window === 'undefined') return;
    try {
      let trackPayload = payload;
      switch (event) {
        case 'insta360Purchase':
          const { orderNumber, orderPaymentInfo, items, care } = payload;

          // 如果当前的商品没有prime仓库的商品，就不需要上报了
          if (items.every((d) => !PrimeCommodityMap[`${d.commodityId}`])) return;
          const primeItems = items
            .map((item) => {
              // 匹配care送赠的额外care
              const matchCare = care.find((o) => o.commodityId === item.commodityId);
              const _item = {
                ...item,
                bind_services: matchCare
                  ? [
                      {
                        id: matchCare.id,
                        serviceType: matchCare.serviceType,
                      },
                    ]
                  : [],
              };
              const primeId = getItemPrimeSkuId(_item);
              if (primeId) {
                return {
                  primeId,
                  ..._item,
                };
              }
              return undefined;
            })
            .filter((d) => !!d);
          if (!primeItems.length) return;

          trackPayload = {
            'orderId': orderNumber,
            'totalPrice': orderPaymentInfo.total,
            'shippingPrice': orderPaymentInfo.ship,
            'totalTax': orderPaymentInfo.salesTax,
            'totalDiscount': formatPrice(orderPaymentInfo.resellerCouponAmount + orderPaymentInfo.couponAmount),
            'productId': primeItems.map((d) => d.primeId).join(','),
            'productPrice': primeItems.map((d) => d.price.amount).join(','),
            'productQuantity': primeItems.map((d) => d.count).join(','),
            'productCurrency': 'usd',
            'currencyCode': 'USD',
          };
          break;
        default:
          break;
      }
      window.VWO = window.VWO || [];
      window.VWO?.event?.(event, trackPayload);
    } catch (e) {
      armsErrorSend(e, { filename: 'BI- VWO Tracker', data: { event, payload } });
    }
  };

  /**
   * @desc: 领英相关事件
   * @param {string} catgory 事件操作 目前领英相关的事件 purchase addToCart
   * @param {object} value 额外信息
   */
  linkedinTrack = (catgory, value = {}) => {
    if (typeof window === 'undefined') return;

    if (!window.lintrk || !window?.CookieConsentInstance) {
      return TrackerQueue.push('Linkedin', this.linkedinTrack, [catgory, value], this);
    }
    if (!window?.CookieConsentInstance?.canLoadSnippets('Linkedin')) return;

    // linkedin设置的标签对应转化ID
    const labelToCoversionId = {
      accessory: '5643745',
      oner: '5643721',
      oneX2: '5643713',
      go2: '5643705',
      professional_camera: '5643737',
      enterprise: '5643729',
      other: '5643753',
    };

    try {
      switch (catgory) {
        case 'purchase':
          // oner, go2, oneX2, accessory, enterprise, professional_camera, other
          const { orderItemInfos = [] } = value;
          const labelToNumberMap = {};
          const labelMap = {
            // 11: "go", 下架
            12: 'oner',
            13: 'oneX2',
            14: 'go2',
          };
          // 下方代码用于判断purchase类型规则：1、是否存在xx相机或者专业相机/行业版。2、是否纯配件。3、若无则label=other
          orderItemInfos.forEach((item) => {
            const isProfessional = productsUnionByType['professional_camera'].includes(item.productId);
            const isEnterprise = productsUnionByType['enterprise'].includes(item.productId);
            if (labelMap[item.productId] || isProfessional || isEnterprise) {
              const itemLabel = labelMap[item.productId]
                ? labelMap[item.productId]
                : isProfessional
                ? 'professional_camera'
                : 'enterprise';
              labelToNumberMap[itemLabel] = labelToNumberMap[itemLabel]
                ? labelToNumberMap[itemLabel] + item.number
                : item.number;
            }
          });

          if (
            JSON.stringify(labelToNumberMap) === '{}' &&
            orderItemInfos
              .filter((item) => !item.isGift)
              .every((item) => !productsUnionByType['nonAccessories'].includes(item.productId))
          ) {
            labelToNumberMap['accessory'] = 1;
          }

          if (JSON.stringify(labelToNumberMap) === '{}') {
            labelToNumberMap['other'] = 1;
          }

          // 购买行为，不会发送给ga，采用本地处理发送的方式
          Object.keys(labelToNumberMap).forEach((label) => {
            for (let i = 0; i < labelToNumberMap[label]; i++) {
              setTimeout(() => {
                window.lintrk && window.lintrk('track', { conversion_id: labelToCoversionId[label] });
              }, 200);
            }
          });
          // 每一次的购买行为
          window.lintrk && window.lintrk('track', { conversion_id: 5643689 });

          break;
        case 'addToCart':
          window.lintrk && window.lintrk('track', { conversion_id: 5643681 });
          break;
        default:
          break;
      }
    } catch (e) {
      armsErrorSend(e, { filename: 'BI- linkedin', data: { catgory, value } });
    }
  };

  /**
   * prime
   */
  primeTracker = ({ action, label = '', value = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_buy_with_prime`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };
}

const T = new ThirdPartyTracker();
export default T;
